import { RouterModule, Routes } from '@angular/router'
import { NgModule } from '@angular/core'

import { AuthGuard } from '../../../services/guarad/auth.guard'
import { LayoutAppElementComponent } from '../layout_app_element/layout-app-element.component'
import { TopCommunicationComponent } from './top-communication/top-communication.component'
import { PendingChangesGuard } from '../../../services/guarad/pending-changes.guard'
import { ListCommunicationComponent } from './list-communication/list-communication.component'
import { NewroomComponent } from './newroom/newroom.component'
import { AvailabilityGuard } from '../../../services/guarad/availability.guard'
import { LayoutAppNotFoundComponent } from '../layout-app-not-found/layout-app-not-found.component'

const routes: Routes = [
    {
        path: 'app/main/communication',
        canActivate: [AuthGuard, AvailabilityGuard],
        component: LayoutAppElementComponent,
        children: [
            { path: '', redirectTo: 'top', pathMatch: 'full', canDeactivate: [PendingChangesGuard] },
            { path: 'top', component: TopCommunicationComponent, canDeactivate: [PendingChangesGuard] },
            { path: 'list', component: ListCommunicationComponent, canDeactivate: [PendingChangesGuard] },
            { path: 'new', component: NewroomComponent, canDeactivate: [PendingChangesGuard] },
            
        ],
    }, {path: 'app/main/communication/not-found', component: LayoutAppNotFoundComponent},
]

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})

export class CommunicationRoutingModule {

}



// WEBPACK FOOTER //
// ./src/app/app_manager/app_element/communication/communication.routing.ts